import { useFieldArray, useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";
import { useNavigate } from "react-router";
import CircleSpinnerLoader from "@/app/components/ui/Reusable/LoaderComponent/CircleSpinnerLoader";
import { useSearchParams } from "react-router-dom";
import { useLabTestListAPI } from "@/app/hooks/api_hooks/LabReport/useLabTestListAPI";
import Input from "@/app/components/ui/Inputs/Input";
import useFormValidations from "@/app/hooks/useFormValidations";
import { useLabTestUpdateListAPI } from "@/app/hooks/api_hooks/LabReport/useLabTestUpdateListAPI";
import LabPartnerSearch from "@/app/components/ui/Reusable/LabPartnerSearch";
import { Search } from "lucide-react";
import { useLoader } from "@/app/hooks/useLoader";
import TestMappingSkeleton from "@/app/components/ui/Skeletons/TestMappingSkeleton";
import { useLabPartnerDetailsAPI } from "@/app/hooks/api_hooks/LabReport/useLabPartnerDetailsAPI";

const PartnerTestMappingComponent = () => {
  const { execute: fetchlabtest, labTestList } = useLabTestListAPI();
  const { execute: updateLabPartnerTest } = useLabTestUpdateListAPI();
  const { execute: fetchpartnerDetails, labPartnerDetails } = useLabPartnerDetailsAPI();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { forNumericWithDecimal } = useFormValidations();
  const [testSearch, setTestSearch] = useState("");

  const isLabTestListInProgress = useLoader("isLabTestListInProgress");

  const [params, _setParams] = useSearchParams();
  const lab_id = params.get("lab_id");

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      lab_partner_status: null,
      lab_test_mapping: [],
    },
  });

  const labTestMapping = useFieldArray<any>({
    name: "lab_test_mapping",
    control: formHook.control,
  });

  const isInitialized = React.useRef(false);

  useEffect(() => {
    if (lab_id) {
      fetchlabtest(lab_id);
      fetchpartnerDetails(lab_id)
    }
  }, [lab_id]);


  // useEffect(() => {
  //   if (labTestList && (!isInitialized.current || labTestList.isCopy)) {
  //     labTestMapping.replace(labTestList?.tests || []);
  //     isInitialized.current = true;
  //   }
  // }, [labTestList]);

  useEffect(() => {
    if (labTestList && (!isInitialized.current || labTestList.isCopy)) {
      labTestMapping.replace(
        (labTestList?.tests || []).map((item: any) => ({
          ...item,
          cost: item.cost === 0 ? null : item.cost,
          lab_tat_hours: item.lab_tat_hours === 0 ? "" : item.lab_tat_hours,
          consumer_tat_hours: item.consumer_tat_hours === 0 ? "" : item.consumer_tat_hours,
        }))
      );
      isInitialized.current = true;
    }
  }, [labTestList]);

  const onSubmit = () => {
    const data = formHook.getValues("lab_test_mapping");

        setLoader(true);
    // const constructedBody = data.filter((item: any) => item.is_active);
    const constructedBody = data
  .filter((item: any) => item.is_active)
  .map((item: any) => ({
    ...item,
    cost: item.cost === 0 || item.cost === "" ? null : item.cost,
  }));

    updateLabPartnerTest(constructedBody, lab_id).then(({ status }) => {
      if (status) {
        navigate(`/app/clinic-lab-report/lab-partner-list`);
      }
      setLoader(false);
    });
  };

  const handelCancel = () => {
    navigate(`/app/clinic-lab-report/lab-partner-onboard?lab_id=${lab_id}&page_step=ONBOARDING`);
  };

  return (
    <form onSubmit={formHook.handleSubmit(onSubmit)} className="w-full min-h-screen bg-[#F9FAFB] p-4 sm:p-4 lg:p-4 pb-24">
      <div className="bg-white p-[20px] rounded-lg shadow-sm border border-gray-100">
        <div className="flex justify-between items-center mb-2 border-b border-gray-50 pb-4">
          <div>
            <h1 className="text-base font-semibold text-gray-900">Partner Test Mapping</h1>
            <p className="text-sm text-gray-500 mt-1">
              Lab Name : <span className="text-black font-semibold">{labPartnerDetails?.lab_name}</span>
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Branch Name : <span className="text-black font-semibold">{labPartnerDetails?.branch_name}</span>
            </p>
          </div>
          <div className="flex items-center gap-4 pr-2">

            <div className="w-[383px]">
              <LabPartnerSearch
                searchType="Lab"
                containerClassName="w-full shadow-none"
                inputContainerClassName="w-full"
                itemActiveClassName="bg-orange-500 text-white"
                flexibleAdd={false}
                onSelectItem={(item) => {
                  if (!item) return;
                  isInitialized.current = false;
                  fetchlabtest(item.id);
                }}
              />
            </div>
          </div>
        </div>

        {labTestMapping?.fields?.length > 0 && (
          <div className={`  rounded-xl    `}>

            <div className="flex justify-between items-center mb-4 gap-4">
              <div className="relative w-full max-w-sm">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Search test name..."
                  value={testSearch}
                  onChange={(e) => setTestSearch(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-100"
                />
              </div>
            </div>

            {isLabTestListInProgress ? (
              <TestMappingSkeleton />
            ) : (
              <div className="overflow-x-auto max-h-[60vh] overflow-y-auto rounded-xl  border-gray-100 relative shadow-sm">
                <table className="w-full border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                  <thead className="bg-[#F5F5F5] text-[#1F1F23] sticky top-0 z-20 font-normal ">
                    <tr>
                      <th className="p-3 pl-2 w-[40%] font-medium text-left text-[8px] sm:text-xs 2xl:text-sm bg-[#F5F5F5]">
                        Lab Test Names
                      </th>
                      <th className="p-3 pl-2 w-[20%] font-medium text-left text-[8px] sm:text-xs 2xl:text-sm bg-[#F5F5F5]">
                        Cost
                      </th>
                      <th className="font-medium w-[20%] text-left text-[8px] sm:text-xs 2xl:text-sm bg-[#F5F5F5]">
                        Lab TAT (Hrs)
                      </th>
                      <th className="font-medium w-[10%] whitespace-nowrap text-left text-[8px] sm:text-xs 2xl:text-sm pr-2 bg-[#F5F5F5]">
                        Consumer TAT (Hrs)
                      </th>
                      <th className="font-medium w-[10%] text-center text-[8px] sm:text-xs 2xl:text-sm pr-2 bg-[#F5F5F5]">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="overflow-hidden rounded-xl w-full bg-white">
                    {labTestMapping?.fields?.map((item, index) => {
                      const isFirst = index === 0;
                      const isLast = index === labTestMapping?.fields?.length - 1;
                      const isSingle = labTestMapping?.fields?.length === 1;

                      const testName = formHook.watch(`lab_test_mapping.${index}.test_name`) || "";
                      const isTestSelected = formHook.watch(`lab_test_mapping.${index}.is_active`);
                      const matchesSearch = testName.toLowerCase().includes(testSearch.toLowerCase());

                      if (!matchesSearch) return null;

                      return (
                        <tr key={item.id}>
                          <td
                            className={`p-2 text-left ${isSingle
                              ? "rounded-tl-xl rounded-bl-xl"
                              : `${isFirst ? "rounded-tl-xl" : ""} ${isLast ? "rounded-b-xl" : ""}`.trim()
                              }`}
                          >
                            <span className="text-xs text-[#1F1F23] break-words font-medium">
                              {formHook.watch(`lab_test_mapping.${index}.test_name`)}
                            </span>
                          </td>

                          {/* COST */}
                          <td className="p-2 text-left">
                            <Input
                              variant="TRANSPARENT"
                              type="number"
                              errorMessages={[{ message: "", type: "required" }, forNumericWithDecimal.errors]}
                              fieldError={formHook?.formState?.errors?.lab_test_mapping?.[index]?.cost ?? null}
                              className="w-24"
                              inputClassName="ring-1 focus:border-1 focus:ring-1 h-8"
                              placeholder="e.g 5"
                              register={formHook.register(`lab_test_mapping.${index}.cost`, {
                                required: false,
                                ...forNumericWithDecimal.validations,
                              })}
                            />
                          </td>

                          {/* LAB TAT */}
                          <td className="p-2 text-left">
                            <Input
                              variant="TRANSPARENT"
                              type="number"
                              errorMessages={[{ message: "", type: "required" }, forNumericWithDecimal.errors]}
                              fieldError={formHook?.formState?.errors?.lab_test_mapping?.[index]?.lab_tat_hours ?? null}
                              className="w-24"
                              inputClassName="ring-1 focus:border-1 focus:ring-1 h-8"
                              placeholder="e.g 5"
                              register={formHook.register(`lab_test_mapping.${index}.lab_tat_hours`, {
                                required: isTestSelected,
                                ...forNumericWithDecimal.validations,
                              })}
                            />
                          </td>

                          {/* CONSUMER TAT */}
                          <td className="p-2 text-left">
                            <Input
                              variant="TRANSPARENT"
                              type="number"
                              errorMessages={[{ message: "", type: "required" }, forNumericWithDecimal.errors]}
                              fieldError={formHook?.formState?.errors?.lab_test_mapping?.[index]?.consumer_tat_hours ?? null}
                              className="w-24"
                              inputClassName="ring-1 focus:border-1 focus:ring-1 h-8"
                              placeholder="e.g 5"
                              register={formHook.register(`lab_test_mapping.${index}.consumer_tat_hours`, {
                                required: isTestSelected,
                                ...forNumericWithDecimal.validations,
                              })}
                            />
                          </td>

                          {/* ACTIVE TOGGLE */}
                          <td
                            className={`p-2 text-center ${isSingle
                              ? "rounded-tr-xl rounded-br-xl"
                              : `${isFirst ? "rounded-tr-xl" : ""} ${isLast ? "rounded-br-xl" : ""}`.trim()
                              }`}
                          >
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                const currentValue = formHook.getValues(`lab_test_mapping.${index}.is_active`);

                                formHook.setValue(`lab_test_mapping.${index}.is_active`, !currentValue, {
                                  shouldDirty: true,
                                });
                              }}
                              className={`relative w-14 h-8 rounded-full transition-colors duration-300
                                 ${formHook.watch(`lab_test_mapping.${index}.is_active`) ? "bg-[#E46A75]" : "bg-gray-300"}`}
                            >
                              <span
                                className={`absolute top-1 left-1 h-6 w-6 bg-white rounded-full
                                    flex items-center justify-center
                                    transition-transform duration-300
                                    ${formHook.watch(`lab_test_mapping.${index}.is_active`) ? "translate-x-6" : "translate-x-0"}`}
                              >
                                {formHook.watch(`lab_test_mapping.${index}.is_active`) && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 text-[#F05B72]"
                                    fill="none"
                                    viewBox="0 0 20 20"
                                    stroke="currentColor"
                                    strokeWidth={3}
                                  >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                  </svg>
                                )}
                              </span>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="fixed bottom-0 left-0 right-0  border-gray-100  py-4 z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <div className="flex justify-end gap-4 pr-12 mx-auto">
          {/* Cancel Button */}
          <button onClick={handelCancel} type="button" className={SECONDARY_BUTTON}>
            Cancel
          </button>

          {/* Onboard Lab Button */}
          <button type="submit" className={`${PRIMARY_BUTTON} min-w-[140px]`}>
            {loader ? <CircleSpinnerLoader w="20" h="20" /> : "Onboard Lab"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default PartnerTestMappingComponent;
